import {Action} from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {PageResponseBillingContractModel} from "@services/back-office/model/pageResponseBillingContractModel";
import {PaginationModel} from "@shared/models/pagination.model";
import {BillingContractSearchModel} from "@services/back-office/model/billingContractSearchModel";
import {BillingContractModel} from "@services/back-office/model/billingContractModel";
import {BillingCounterpartyModel} from "@services/back-office/model/billingCounterpartyModel";

export enum ContractsActionTypes {
    LoadContracts = '[Contracts] Load Contracts',
    LoadContractsSuccess = '[Contracts] Load Contracts Success',
    LoadContractsFailure = '[Contracts] Load Contracts Failure',
    AddContracts = '[Contracts] Add Contracts',
    AddContractsSuccess = '[Contracts] Add Contracts Success',
    AddContractsFailure = '[Contracts] Add Contracts Failure',
    EditContracts = '[Contracts] Edit Contracts',
    EditContractsSuccess = '[Contracts] Edit Contracts Success',
    EditContractsFailure = '[Contracts] Edit Contracts Failure',
    UpdateContract = '[Contracts] Update Contracts',
    UpdateContractSuccess = '[Contracts] Update Contracts Success',
    DeleteContracts = '[Contracts] Delete Contracts',
    DeleteContractsSuccess = '[Contracts] Delete Contracts Success',
    DeleteContractsFailure = '[Contracts] Delete Contracts Failure',
    ChangePage = '[Contracts] Change Page',
    SetInitialPagination = '[Contracts] Set Initial Pagination',
    SetFilter = '[Contracts] Set Filter',
    ClearFilter = '[Contracts] Clear Filter',
    SetInitialState = '[Contracts] Set Initial State',
    AddEditCounterPartySuccess = '[Contracts] Add Edit CounterParty Success',
}

export class LoadContracts implements Action {
    readonly type = ContractsActionTypes.LoadContracts;
    constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadContractsSuccess implements Action {
    readonly type = ContractsActionTypes.LoadContractsSuccess;
    constructor(public payload: PageResponseBillingContractModel) { }
}

export class LoadContractsFailure implements Action {
    readonly type = ContractsActionTypes.LoadContractsFailure;
    constructor(public payload: HttpErrorResponse) { }
}


/** Add Agreements */
export class AddContracts implements Action {
    readonly type = ContractsActionTypes.AddContracts;
    constructor(public payload: BillingContractModel) { }
}

export class AddContractsSuccess implements Action {
    readonly type = ContractsActionTypes.AddContractsSuccess;
    constructor(public payload: BillingContractModel) { }
}

export class AddContractsFailure implements Action {
    readonly type = ContractsActionTypes.AddContractsFailure;
    constructor(public payload: HttpErrorResponse) { }
}

/** Edit Contracts */
export class EditContracts implements Action {
    readonly type = ContractsActionTypes.EditContracts;
    constructor(public payload: BillingContractModel) { }
}

export class EditContractsSuccess implements Action {
    readonly type = ContractsActionTypes.EditContractsSuccess;
    constructor(public payload: BillingContractModel) { }
}

export class EditContractsFailure implements Action {
    readonly type = ContractsActionTypes.EditContractsFailure;
    constructor(public payload: HttpErrorResponse) { }
}

export class UpdateContract implements Action {
    readonly type = ContractsActionTypes.UpdateContract;
    constructor(public payload: string) { }
}

export class UpdateContractSuccess implements Action {
    readonly type = ContractsActionTypes.UpdateContractSuccess;
    constructor(public payload: BillingContractModel) { }
}

/** Delete Contracts */
export class DeleteContracts implements Action {
    readonly type = ContractsActionTypes.DeleteContracts;
    constructor(public payload: string) { }
}

export class DeleteContractsSuccess implements Action {
    readonly type = ContractsActionTypes.DeleteContractsSuccess;
    constructor(public payload: string) { }
}

export class DeleteContractsFailure implements Action {
    readonly type = ContractsActionTypes.DeleteContractsFailure;
    constructor(public payload: HttpErrorResponse) { }
}

/** Change Page */
export class ChangePage implements Action {
    readonly type = ContractsActionTypes.ChangePage;
    constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
    readonly type = ContractsActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
    readonly type = ContractsActionTypes.SetFilter;
    constructor(public payload: BillingContractSearchModel) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
    readonly type = ContractsActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
    readonly type = ContractsActionTypes.SetInitialState;
}

export class AddEditCounterPartySuccess implements Action {
    readonly type = ContractsActionTypes.AddEditCounterPartySuccess;
    constructor(public payload: BillingCounterpartyModel) {
    }
}

export type ContractsActions =
    | LoadContracts
    | LoadContractsSuccess
    | LoadContractsFailure
    | AddContracts
    | AddContractsSuccess
    | AddContractsFailure
    | EditContracts
    | EditContractsSuccess
    | EditContractsFailure
    | UpdateContract
    | UpdateContractSuccess
    | DeleteContracts
    | DeleteContractsSuccess
    | DeleteContractsFailure
    | ChangePage
    | SetInitialPagination
    | SetFilter
    | ClearFilter
    | SetInitialState
    | AddEditCounterPartySuccess
    ;
